import * as React from 'react';
import { BaseModel } from './BaseModel';

interface IOutFalls {
    Outfall1: boolean;
    Outfall2: boolean;
    Outfall3: boolean;
    Outfall4: boolean;
    Outfall5: boolean;
    Outfall6: boolean;
}

interface IInspections {
    DailyForm: boolean;
    PlantPreventive: boolean;
    MonthlySPCC: boolean;
    MonthlySpillLogs: boolean;
    MonthlySW: boolean;
    MonthlyUSTRect: boolean;
    MonthlyUSTSpill: boolean;
    QTRVisual: boolean;
    ShopInspection: boolean;
}

interface IPlantModelProps {
    id: string;
    Outfalls: IOutFalls;
    Inspections: IInspections;
    Street: string;
    Country: string;
    State: string;
    PlantId: string;
    Plant_Region: string;
    ZipCode?: number;
    Zip?: number;
    City: string;
    Users?: string[];
    Plant_Name: string;
}

export class PlantModel extends BaseModel<IPlantModelProps> {
    constructor(props: IPlantModelProps) {
        super(props);
    }

    static resource = 'plant';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/PlantModel.tsx